import * as React from 'react';
import { cn } from '../../lib/utils';

export const Table = React.forwardRef(({ className, containerProps, ...props }, ref) => (
  <div {...containerProps} className="relative w-full overflow-auto tm-scrollbar tm-scroll-area focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
    <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} />
  </div>
));
Table.displayName = 'Table';
export const TableHeader = React.forwardRef(({ className, ...props }, ref) => <thead ref={ref} className={cn('[&_tr]:border-b [&_tr]:border-slate-300', className)} {...props} />);
TableHeader.displayName = 'TableHeader';
export const TableBody = React.forwardRef(({ className, ...props }, ref) => <tbody ref={ref} className={cn('[&_tr:last-child]:border-0', className)} {...props} />);
TableBody.displayName = 'TableBody';
export const TableRow = React.forwardRef(({ className, ...props }, ref) => <tr ref={ref} className={cn('border-b border-slate-300 transition-colors hover:bg-slate-50', className)} {...props} />);
TableRow.displayName = 'TableRow';
export const TableHead = React.forwardRef(({ className, ...props }, ref) => <th ref={ref} className={cn('h-11 px-4 text-left align-middle text-xs font-bold uppercase tracking-wider text-muted-foreground', className)} {...props} />);
TableHead.displayName = 'TableHead';
export const TableCell = React.forwardRef(({ className, ...props }, ref) => <td ref={ref} className={cn('p-4 align-middle', className)} {...props} />);
TableCell.displayName = 'TableCell';
